import { SliceCaseReducers } from '@reduxjs/toolkit'
import { ProductOperationParams, ProductOperationResponse } from '@repo/accounts-types'
import { createOperationSlice, GenericOperationState } from '@repo/core'

const initialState: GenericOperationState<ProductOperationResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const {
  actions: productOperationsMasterListActions,
  reducer: productOperationsMasterListReducer,
} = createOperationSlice<
  ProductOperationResponse | null,
  SliceCaseReducers<GenericOperationState<ProductOperationResponse | null>>,
  ProductOperationParams
>({
  name: '@accounts/master/list/operations',
  initialState,
  reducers: {},
})
